import PropTypes from 'prop-types';
import { Component } from 'react';
import I18n from 'I18n';
import UIConfirmModal from 'UIComponents/dialog/UIConfirmModal';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIFireAlarm from 'UIComponents/alert/UIFireAlarm';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class TrustedNumberConfirmationModal extends Component {
  render() {
    const showError = this.props.deleteError !== undefined;
    return /*#__PURE__*/_jsx(UIConfirmModal, {
      use: "conversational",
      message: I18n.text(`userPreferences.${this.props.modalKey}.header`),
      description: /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: `userPreferences.${this.props.modalKey}.body`
        }), showError && /*#__PURE__*/_jsx(UIFireAlarm, {
          titleText: I18n.text(`userPreferences.deleteTrustedPhoneNumber.titleError`),
          type: "danger",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `userPreferences.deleteTrustedPhoneNumber.error`
          })
        })]
      }),
      confirmLabel: I18n.text(`userPreferences.${this.props.modalKey}.affirmButton`),
      confirmUse: "danger",
      onConfirm: this.props.trustedNumberAction,
      rejectLabel: I18n.text(`userPreferences.${this.props.modalKey}.cancelButton`),
      onReject: this.props.closeModal
    });
  }
}
TrustedNumberConfirmationModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  trustedNumberAction: PropTypes.func.isRequired,
  modalKey: PropTypes.string.isRequired,
  deleteError: PropTypes.bool
};
export default TrustedNumberConfirmationModal;